<header class="b4a-tv-header">
  <div class="b4a-tv-header-content">
    <div class="b4a-tv-title-section">
      <h1 class="b4a-tv-main-title">
        {{ title }}
      </h1>
    </div>

    <div class="b4a-tv-status" *ngIf="showStatus">
      <span class="b4a-status-indicator" [ngClass]="statusIndicatorClass"></span>
      <span class="b4a-status-text">
        {{ statusText }}
      </span>
    </div>

    <ng-content select="[dashboard-header-extra]"></ng-content>
  </div>
</header>

